/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Operation } from './Operation';
import {
    OperationFromJSON,
    OperationFromJSONTyped,
    OperationToJSON,
} from './Operation';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface ListOperations200Response
 */
export interface ListOperations200Response {
    /**
     * 
     * @type {Array<Operation>}
     * @memberof ListOperations200Response
     */
    results: Array<Operation>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof ListOperations200Response
     */
    pagination: PaginationInfo;
}

/**
 * Check if a given object implements the ListOperations200Response interface.
 */
export function instanceOfListOperations200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "pagination" in value;

    return isInstance;
}

export function ListOperations200ResponseFromJSON(json: any): ListOperations200Response {
    return ListOperations200ResponseFromJSONTyped(json, false);
}

export function ListOperations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOperations200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(OperationFromJSON)),
        'pagination': PaginationInfoFromJSON(json['pagination']),
    };
}

export function ListOperations200ResponseToJSON(value?: ListOperations200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(OperationToJSON)),
        'pagination': PaginationInfoToJSON(value.pagination),
    };
}

